module.exports = __webpack_public_path__ + "static/language-c04fb4e59c452dda27de490d15e4e0d5.png";